import React, { Component } from "react";
import CartContext from "./CartContext";
import { SideMenu } from "./SideMenu";
import { RawMaterialCategory } from "./RawMaterialCategory";
import { BiSave, BiRefresh, BiUpload, BiDownload } from "react-icons/bi";
import { BsFillPencilFill } from "react-icons/bs";
import { MessageBox } from "./MessageBox";
import { LoadSpinner } from "./LoadSpinner";
import axios from "axios";
import Fuse from "fuse.js";
import { Country, State, City } from "country-state-city";

import {
  OverlayTrigger,
  Tooltip,
  Stack,
  FormControl,
  Button,
  ButtonToolbar,
  Form,
  Row,
  Col,
  Modal,
  InputGroup,
  Nav,
  Table,
  Navbar,
} from "react-bootstrap";

export class SalesLeadDb extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      salesleaddb: [],
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      reload: true,
      rawmaterialcategory: [],
      salesleaddbFiltered: [],
      categoryFilterName: "",
      loadSpinnerOpen: false,
    };
    this.inputFile = React.createRef();
  }
  SetCategoryFilterName = (cname) => {
    this.setState({ reload: false });
    this.setState({ categoryFilterName: cname }, () => {
      this.setState({ reload: true });
    });
  };

  GetSalesLeadDb = () => {
    fetch(
      process.env.REACT_APP_API +
        "Leads//GetSalesLeadDb/" +
        this.context.storeId
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          this.setState({
            salesleaddbFiltered: data,
          });
          this.setState({ salesleaddb: data }, () => {
            this.setState({ reload: false }, () => {
              this.setState({ reload: true });
            });
          });
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
  };

  OnSaved = () => {
    this.OnRefreshButtonClick();
  };
  OnDeleted = () => {
    this.OnRefreshButtonClick();
  };

  OnRefreshButtonClick = () => {
    this.setState({ salesleaddb: [] }, () => {
      this.GetSalesLeadDb();
    });
  };
  ShowMessagBox = (title, message) => {
    this.setState({ msgboxOpen: true });
    this.setState({ msgboxTitle: title });
    this.setState({ msgboxMessage: message });
  };

  OnUpdated = (indexno) => {
    this.OnRefreshButtonClick();
  };

  addModalClose = () => {
    this.setState({ addModalShow: false }, () => {});
    this.OnRefreshButtonClick();
  };

  onSearchChange = (query) => {
    this.setState({ reload: false });
    this.setState({ searchquery: query });
    if (!query) {
      this.setState({ salesleaddbFiltered: this.state.salesleaddb }, () => {
        this.setState({ reload: true });
      });
      return;
    }
    const fuse = new Fuse(this.state.salesleaddb, {
      keys: ["name"],
      threshold: 0.6,
      ignoreLocation: true,
      findAllMatches: true,
      includeMatches: true,
      distance: 120,
    });
    const result = fuse.search(query);
    const finalResult = [];
    if (result.length) {
      result.forEach((item) => {
        finalResult.push(item.item);
      });
      this.setState({ salesleaddbFiltered: finalResult.slice(0, 25) }, () => {
        this.setState({ reload: true });
      });
    } else {
      this.setState({ salesleaddbFiltered: [] });
    }
  };

  onUploadButtonClick = () => {
    this.inputFile.current.click();
  };
  ShowLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: true });
  };
  HideLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: false });
  };

  handleFileUpload = (e) => {
    this.ShowLoadSpinner();
    const { files } = e.target;

    const reader = new FileReader();
    reader.onload = (e) => {
      const text = e.target.result;
      this.UploadProductsFromCSV(text);
    };
    reader.readAsText(files[0]);
  };

  UploadProductsFromCSV = (csvstr) => {
    this.ShowLoadSpinner();
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(csvstr),
    };

    fetch(
      process.env.REACT_APP_API +
        "Leads/UploadSalesLeadDbFromCsv/" +
        this.context.storeId,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 404) {
          return;
        }
        this.OnRefreshButtonClick();
        this.HideLoadSpinner();
        this.ShowMessagBox(
          "Information",
          "Uploaded Successfully. Please Refresh(f5) the Portal! \r\n" +
            "\r\n" +
            data
        );
      })
      .catch((error) => {
        this.HideLoadSpinner();
        // this.ShowMessagBox("Failed", "Unable to Add! try later");
        alert("Failed" + error);
      });
  };
  DownloadProductsToCSV = () => {
    this.ShowLoadSpinner();
    var res = axios
      .get(
        process.env.REACT_APP_API +
          "Leads/DownloadSalesLeadDbToCSV/" +
          this.context.storeId
      )
      .then((response) => {
        if (response.status === 200) {
          this.HideLoadSpinner();
          const element = document.createElement("a");
          const file = new Blob([response.data], {
            type: "text/plain",
          });
          element.href = URL.createObjectURL(file);
          element.download =
            "rawleads-" +
            new Date().getDate() +
            (new Date().getMonth() + 1) +
            new Date().getFullYear() +
            "-" +
            new Date().getMinutes() +
            new Date().getSeconds() +
            ".csv";
          document.body.appendChild(element); // Required for this to work in FireFox
          element.click();
        } else {
          this.HideLoadSpinner();
          this.ShowMessagBox("Error", "Download Failed. Please try later!");
        }
      })
      .catch((error) => {
        this.HideLoadSpinner();
        console.error("DownloadProductsToCSV - There was an error! ", error);
      });
  };

  componentDidMount = () => {
    window.scrollTo(0, 0);
    if (this.state.salesleaddb.length == 0) {
      this.GetSalesLeadDb();
    }
  };

  render() {
    return (
      <>
        {this.state.loadSpinnerOpen === true ? (
          <LoadSpinner open="true"></LoadSpinner>
        ) : (
          ""
        )}
        <div className="Container-fluid p-0 ">
          <Row>
            <Col xs={12} className="pagebackground p-0">
              <input
                style={{ display: "none" }}
                accept=".csv"
                ref={this.inputFile}
                onChange={this.handleFileUpload}
                type="file"
                multiple="single"
              />
              <Row>
                <Col xs={12}>
                  <div
                    className="fixedTableHightOrder"
                    style={{
                      height: window.innerHeight - 90 + "px",
                    }}
                  >
                    {this.state.msgboxOpen === true ? (
                      <MessageBox
                        open={this.state.msgboxOpen}
                        title={this.state.msgboxTitle}
                        message={this.state.msgboxMessage}
                        callback={this.CloseMessagBoxCallback}
                      />
                    ) : (
                      ""
                    )}
                    <Navbar
                      expand="lg"
                      className="position-sticky fixed-top  px-3"
                    >
                      {/* <h5>
                        {" "}
                        &nbsp; &nbsp;<b>Leads Raw DB</b> &nbsp;
                      </h5> */}
                      <Navbar.Collapse className="justify-content-end mx-0 ">
                        <Nav>
                          <ButtonToolbar className="text-end align-middle">
                            <Button
                              className="mainthemecolor"
                              // onClick={() => this.handleAddSalesLeadDb()}
                              onClick={() =>
                                this.setState({ addModalShow: true })
                              }
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                class="bi bi-plus"
                                viewBox="0 0 16 16"
                              >
                                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                              </svg>
                              Add
                            </Button>
                            &nbsp;
                            <Button
                              className="mainthemecolor"
                              size=""
                              onClick={() => this.OnRefreshButtonClick()}
                            >
                              <BiRefresh size="20"></BiRefresh>
                              Refresh
                            </Button>
                            &nbsp;
                            <Button
                              className="bg-warning text-dark buttonRounded"
                              // onClick={() => this.setState({ addModalShow: true })}
                              onClick={(e) => this.onUploadButtonClick()}
                            >
                              <BiUpload
                                size="20"
                                className="bg-warning text-dark"
                              ></BiUpload>
                              Upload from CSV
                            </Button>
                            &nbsp;
                            <Button
                              className="bg-warning text-dark buttonRounded"
                              size=""
                              onClick={(e) => this.DownloadProductsToCSV()}
                            >
                              <BiDownload
                                size="20"
                                className="bg-warning text-dark"
                              ></BiDownload>
                              Download as CSV
                            </Button>
                            {this.state.addModalShow === true ? (
                              <SalesLeadDbAddOrEditModal
                                show={this.state.addModalShow}
                                Type="Add"
                                onHide={this.addModalClose}
                                rawmaterialcategory={
                                  this.state.rawmaterialcategory
                                }
                              />
                            ) : null}
                          </ButtonToolbar>
                        </Nav>
                      </Navbar.Collapse>
                    </Navbar>
                    <div className="p-3">
                      <Row>
                        <Col>
                          <Stack direction="horizontal" gap={3} className="">
                            <b>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                class="bi bi-search"
                                viewBox="0 0 16 16"
                              >
                                <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                              </svg>
                            </b>
                            <FormControl
                              type="search"
                              placeholder="Search  "
                              className="text-primary fw-bold bg-white "
                              aria-label="Search"
                              onChange={(e) =>
                                this.onSearchChange(e.target.value)
                              }
                            />
                          </Stack>
                        </Col>
                      </Row>
                    </div>
                    <div>
                      <Table border striped className="px-0 bg-white ">
                        <thead className="">
                          <tr className="text-start text-black bg-white border">
                            <th width="2%"></th>
                            <th width="10%" className="text-start">
                              Contact Person Name
                            </th>
                            <th width="13%" className="text-start">
                              Company Name
                            </th>
                            <th width="10%" className="text-start">
                              MobileNo
                            </th>
                            <th width="10%" className="text-start">
                              MobileNo2
                            </th>
                            <th width="10%" className="text-start">
                              Email Id
                            </th>
                            <th width="10%" className="text-start">
                              Address
                            </th>
                            <th width="10%" className="text-start">
                              City
                            </th>
                            <th width="20%" className="text-end">
                              Options
                            </th>
                          </tr>
                        </thead>
                        <tbody className="text-primary border">
                          {this.state.salesleaddbFiltered
                            .filter((f) => {
                              if (
                                this.state.categoryFilterName != "" &&
                                this.state.categoryFilterName == f.categoryId
                              ) {
                                return true;
                              } else if (this.state.categoryFilterName == "") {
                                return true;
                              } else {
                                return false;
                              }
                            })
                            // .filter((f) => {
                            //   if (this.state.categoryFilterName == "") return true;
                            // })
                            .sort((a, b) =>
                              a.name.toUpperCase() > b.name.toUpperCase()
                                ? 1
                                : -1
                            )
                            .map((salesleaddb, i) =>
                              this.state.reload === true ? (
                                <EditSalesLeadDbInline
                                  index={i}
                                  salesleaddb={salesleaddb}
                                  OnDeleted={this.OnDeleted}
                                  rawmaterialcategory={
                                    this.state.rawmaterialcategory
                                  }
                                ></EditSalesLeadDbInline>
                              ) : null
                            )}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </>
    );
  }
}

export class EditSalesLeadDbInline extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      salesleaddb: "",
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      loadSpinnerOpen: false,
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      editModalShow: false,
    };
  }

  ShowMessagBox = (title, message) => {
    this.setState({ msgboxOpen: true });
    this.setState({ msgboxTitle: title });
    this.setState({ msgboxMessage: message });
  };
  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
  };

  ShowLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: true });
  };
  HideLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: false });
  };
  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
  };

  OnDelete = () => {
    if (this.state.salesleaddb.id == undefined) {
      this.ShowMessagBox(
        "Information",
        "This is invalid row which can't be deleted. Press Refresh!"
      );
      return;
    }

    this.ShowLoadSpinner();
    const requestOptions = {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
    };

    fetch(
      process.env.REACT_APP_API +
        "Leads/DeleteSalesLeadDb/" +
        this.state.salesleaddb.id,
      requestOptions
    )
      .then((res) => {
        if (res.status != 200) {
          this.HideLoadSpinner();
          alert(
            "Not deleted. This SalesLeadDb may be associated with few Products. First disassociate this salesleaddb from the Products and then try!"
          );
          return;
        }
        this.HideLoadSpinner();
        this.ShowMessagBox(
          "Status",
          "Deleted Successfully. Click Refresh Button to see the changes!"
        );
        this.props.OnDeleted();
      })
      .catch((error) => {
        this.HideLoadSpinner();
        alert("OnDelete Failed" + error);
      });
  };
  AddOrUpdateLeadInDB = () => {
    if (
      this.state.salesleaddb.mobileNo == "" ||
      (this.state.salesleaddb.mobileNo != "" &&
        this.state.salesleaddb.mobileNo.length != 10)
    ) {
      alert("Invalid MobileNo. Enter a valid Customer Mobile number and try!");
      return;
    }

    this.ShowLoadSpinner();

    var tmpLead = {
      storeId: this.context.storeId,
      customerName: this.state.salesleaddb.name,
      mobileNo: this.state.salesleaddb.mobileNo,
      emailId: this.state.salesleaddb.emailId,
      address: this.state.salesleaddb.address,
      city: this.state.salesleaddb.city,
      status: 1,
    };

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(tmpLead),
    };

    fetch(
      process.env.REACT_APP_API + "Leads/AddOrUpdateSalesLead/",
      requestOptions
    )
      .then((res) => {
        if (res.status == 200) {
          this.HideLoadSpinner();
          return;
        }
        this.HideLoadSpinner();
        alert("This Lead is already exist. try again!");
        return;
      })
      .catch((error) => {
        this.HideLoadSpinner();
        alert("Exception. Received an Exception. Try after sometime !" + error);
      });
  };

  componentDidMount = () => {
    this.setState({ salesleaddb: this.props.salesleaddb });
  };
  OnEditButtonClick = () => {
    this.setState({ editModalShow: true }, () => {});
  };

  editModalClose = () => {
    this.setState({ editModalShow: false }, () => {});
  };

  render() {
    return (
      <>
        {this.state.editModalShow === true ? (
          <SalesLeadDbAddOrEditModal
            show={this.state.editModalShow}
            onHide={this.editModalClose}
            salesleaddb={this.state.salesleaddb}
            Type="Edit"
            rawmaterialcategory={this.props.rawmaterialcategory}
          />
        ) : (
          ""
        )}
        {this.state.loadSpinnerOpen === true ? (
          <LoadSpinner open="true"></LoadSpinner>
        ) : (
          ""
        )}
        <tr
          className="text-center align-middle text-secondary bg-white mx-5"
          style={{ fontSize: "12px" }}
        >
          {this.state.msgboxOpen === true ? (
            <MessageBox
              open={this.state.msgboxOpen}
              title={this.state.msgboxTitle}
              message={this.state.msgboxMessage}
              callback={this.CloseMessagBoxCallback}
            />
          ) : (
            ""
          )}
          <td>{this.props.index + 1}</td>
          <td className="text-start ">{this.state.salesleaddb.name}</td>
          <td className="text-start ">{this.state.salesleaddb.companyName}</td>
          <td className="text-start ">{this.state.salesleaddb.mobileNo}</td>
          <td className="text-start ">{this.state.salesleaddb.mobileNo2}</td>
          <td className="text-start ">{this.state.salesleaddb.emailId}</td>
          <td className="text-start ">{this.state.salesleaddb.address}</td>
          <td className="text-start ">{this.state.salesleaddb.city}</td>

          <td className="col-md-2 text-end align-middle ">
            <div class="btn-group">
              <OverlayTrigger overlay={<Tooltip>Edit!</Tooltip>}>
                <Button
                  variant="warning"
                  onClick={(e) => {
                    this.OnEditButtonClick(e);
                  }}
                >
                  <BsFillPencilFill size="16" />
                </Button>
              </OverlayTrigger>
              &nbsp;&nbsp;
              <OverlayTrigger overlay={<Tooltip>Edit!</Tooltip>}>
                <Button
                  variant="success"
                  onClick={(e) => {
                    this.AddOrUpdateLeadInDB();
                  }}
                >
                  Add to New Lead
                </Button>
              </OverlayTrigger>
              <OverlayTrigger
                overlay={
                  <Tooltip>Warning! This will delete all dependents.</Tooltip>
                }
              >
                <Button
                  className="mx-1 "
                  variant="danger"
                  disabled={
                    this.context.UserRoles.PRODUCTADMIN ==
                    this.context.userData.roleId
                      ? false
                      : true
                  }
                  onClick={(e) => {
                    if (
                      window.confirm(
                        "Warning! This action will delete all it dependents. Are you sure you want to Delete?"
                      )
                    ) {
                      this.OnDelete(e);
                    }
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-trash"
                    viewBox="0 0 16 16"
                  >
                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                    <path
                      fill-rule="evenodd"
                      d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                    />
                  </svg>
                </Button>
              </OverlayTrigger>
            </div>
          </td>
        </tr>
      </>
    );
  }
}

export class SalesLeadDbAddOrEditModal extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);

    this.state = {
      salesleaddb: {
        name: "",
      },
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      loadSpinnerOpen: false,
    };
  }

  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
    this.props.onHide();
  };
  ShowMessagBox = (title, message) => {
    this.setState({ msgboxOpen: true });
    this.setState({ msgboxTitle: title });
    this.setState({ msgboxMessage: message });
  };
  ShowLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: true });
  };
  HideLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: false });
  };

  AddOrUpdateSalesLeadDbInDB = () => {
    this.ShowLoadSpinner();

    var tmpSalesLeadDb = this.state.salesleaddb;
    if (this.props.Type == "Edit") {
      tmpSalesLeadDb = this.props.salesleaddb;
    } else {
      tmpSalesLeadDb.storeId = this.context.storeId;
    }
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(tmpSalesLeadDb),
    };

    fetch(
      process.env.REACT_APP_API + "Leads/AddOrUpdateSalesLeadDb/",
      requestOptions
    )
      .then((res) => {
        if (res.status == 200) {
          this.HideLoadSpinner();
          this.props.onHide();
          return;
        }
        this.HideLoadSpinner();
        alert("This SalesLeadDb is already exist. try again!");
        return;
      })
      .catch((error) => {
        this.HideLoadSpinner();
        alert("Exception. Received an Exception. Try after sometime !" + error);
      });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.AddOrUpdateSalesLeadDbInDB();
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;

    switch (name.trim()) {
      case "name":
        this.state.salesleaddb.name = value;
        break;
      case "companyName":
        this.state.salesleaddb.companyName = value;
        break;
      case "mobileNo":
        if (Number.isInteger(Number(value)))
          this.state.salesleaddb.mobileNo = value;
        break;
      case "mobileNo2":
        if (Number.isInteger(Number(value)))
          this.state.salesleaddb.mobileNo2 = value;
        break;
      case "emailId":
        this.state.salesleaddb.emailId = value;
        break;
      case "address":
        this.state.salesleaddb.address = value;
        break;
      case "city":
        this.state.salesleaddb.city = value;
        break;
      case "state":
        this.state.salesleaddb.state = value;
        break;
      case "country":
        this.state.salesleaddb.country = value;
        break;
      case "pinCode":
        this.state.salesleaddb.pinCode = value;
        break;
    }
    this.setState({ salesleaddb: this.state.salesleaddb });
  };

  componentDidMount() {
    if (this.props.Type == "Edit") {
      this.setState({
        salesleaddb: this.props.salesleaddb,
      });
    }
    if (document.getElementById("name") != null)
      document.getElementById("name").focus();
  }

  render() {
    return (
      <div className="container ">
        <Modal
          {...this.props}
          size="xl"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          backdrop="static"
          keyboard={false}
          dialogClassName="SalesLeadDbModal"
        >
          {this.state.msgboxOpen === true ? (
            <MessageBox
              open={this.state.msgboxOpen}
              title={this.state.msgboxTitle}
              message={this.state.msgboxMessage}
              callback={this.CloseMessagBoxCallback}
            />
          ) : (
            ""
          )}
          {this.state.loadSpinnerOpen === true ? (
            <LoadSpinner open="true"></LoadSpinner>
          ) : (
            ""
          )}
          <Form onSubmit={this.handleSubmit}>
            <Modal.Header closeButton className="bg-warning">
              <Modal.Title id="contained-modal-title-vcenter">
                {this.props.Type == "Edit" ? "Edit Lead" : "Add Lead"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="show-grid ">
              <Row
                className="m-2 p-2 bg-light border"
                style={{ fontSize: "12pt" }}
              >
                <Col md={12}>
                  <Form.Group as={Row} className="mb-3 " controlId="">
                    <Form.Label column sm="3">
                      Contact Person Name
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        type="text"
                        id="name"
                        name="name"
                        maxlength="99"
                        value={this.state.salesleaddb.name}
                        required
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3 " controlId="">
                    <Form.Label column sm="3">
                      Company Name
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        type="text"
                        id="companyName"
                        name="companyName"
                        maxlength="99"
                        value={this.state.salesleaddb.companyName}
                        required
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3 " controlId="">
                    <Form.Label column sm="3">
                      Mobile Number
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        type="text"
                        id="mobileNo"
                        name="mobileNo"
                        maxlength="10"
                        value={this.state.salesleaddb.mobileNo}
                        required
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3 " controlId="">
                    <Form.Label column sm="3">
                      Mobile Number2
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        type="text"
                        id="mobileNo2"
                        name="mobileNo2"
                        maxlength="10"
                        value={this.state.salesleaddb.mobileNo2}
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3 " controlId="">
                    <Form.Label column sm="3">
                      Email Id
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        type="email"
                        id="emailId"
                        name="emailId"
                        maxlength="99"
                        value={this.state.salesleaddb.emailId}
                        required
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3 " controlId="">
                    <Form.Label column sm="3">
                      Address
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        type="text"
                        id="address"
                        name="address"
                        maxlength="199"
                        value={this.state.salesleaddb.address}
                        required
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3 " controlId="">
                    <Form.Label column sm="3">
                      City
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        type="text"
                        id="city"
                        name="city"
                        maxlength="199"
                        value={this.state.salesleaddb.city}
                        required
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      />
                    </Col>
                  </Form.Group>
                  {/* <Form.Group as={Row} className="mb-3 " controlId="">
                    <Form.Label column sm="3">
                      Country
                    </Form.Label>
                    <Col sm="9">
                      <Form.Select
                        type="text"
                        name="country"
                        value={this.state.salesleaddb.country}
                        required
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      >
                        <option value=""></option>
                        {Country.getAllCountries().map((country) => (
                          <>
                            <option value={country.isoCode}>
                              {country.name}
                            </option>
                          </>
                        ))}
                      </Form.Select>
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3 " controlId="">
                    <Form.Label column sm="3">
                      State
                    </Form.Label>
                    <Col sm="9">
                      <Form.Select
                        type="text"
                        name="state"
                        value={this.state.salesleaddb.state}
                        required
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      >
                        <option value=""></option>
                        {State.getStatesOfCountry(
                          this.state.salesleaddb.country
                        ).map((s1) => (
                          <>
                            <option>{s1.name}</option>
                          </>
                        ))}
                      </Form.Select>
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3 " controlId="">
                    <Form.Label column sm="3">
                      PinCode
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        type="text"
                        name="pinCode"
                        required
                        maxlength="9"
                        value={this.state.salesleaddb.pinCode}
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      />
                    </Col>
                  </Form.Group> */}
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer className="bg-light">
              <Form.Group>
                <Button variant="primary" size="lg" type="submit">
                  Save
                </Button>
              </Form.Group>

              <Button variant="danger" size="lg" onClick={this.props.onHide}>
                Close
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      </div>
    );
  }
}
